export default {
    root: ({props, context, parent, instance}) => ({
        class: [
            "relative",

            // Alignments
            "items-center inline-flex text-center align-bottom justify-center",
            {"flex-col": (props.iconPos === "top" || props.iconPos === "bottom") && props.label},

            // Sizes & Spacing
            "leading-[normal]",

            // Shapes
            {"rounded-none first:rounded-l-md last:rounded-r-md": parent.instance.$name == "InputGroup"},

            // --- Severity Button States ---
            "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-askr-green/40",

            // Link
            {"focus:ring-askr-green": props.link},

            // Disabled
            {"opacity-60 pointer-events-none cursor-default": context.disabled},

            // Transitions
            "transition duration-200 ease-in-out",

            // Misc
            "cursor-pointer overflow--hidden select-none",

            // Badge
            "[&>[data-pc-name=badge]]:min-w-4 [&>[data-pc-name=badge]]:h-4 [&>[data-pc-name=badge]]:leading-4",
        ],
    }),
};
